import { classes, Heading } from '@dittolive/anvil'
import React from 'react'

type PageHeaderProps = {
  /** Page title, rendered as the page's single level-1 heading. */
  title: React.ReactNode
  /** Short supporting line rendered under the title. */
  description?: React.ReactNode
  /** Actions rendered on the trailing edge of the header. */
  children?: React.ReactNode
  className?: string
}

/**
 * Standard page header: a level-1 heading with an optional muted
 * description and optional trailing actions. Use once at the top of every
 * page instead of hand-rolling Heading + description markup.
 */
export function PageHeader({
  title,
  description,
  children,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={classes(
        'mb-6 flex items-start justify-between gap-4',
        className,
      )}
    >
      <div>
        <Heading level={1}>{title}</Heading>
        {description && (
          <p className="text-foreground-subtle mt-1 max-w-prose">
            {description}
          </p>
        )}
      </div>
      {children}
    </div>
  )
}
